import "@xyflow/react/dist/style.css";

import { appRouter } from "app/AppRouter";
import { AppChakraProvider } from "app/provider/AppChakraProvider";
import { AppIntercomProvider } from "app/provider/AppIntercomProvider";
import { AppMathJaxProvider } from "app/provider/AppMathJaxProvider";
import { AppQueryClientProvider } from "app/provider/AppQueryClientProvider";
import { AppStytchProvider } from "app/provider/AppStytchProvider";
import { IndexLoading } from "idx/IndexLoading";
import { RouterProvider } from "react-router-dom";

const App = () => (
  <AppIntercomProvider>
    <AppStytchProvider>
      <AppChakraProvider>
        <AppMathJaxProvider>
          <AppQueryClientProvider>
            <RouterProvider
              router={appRouter}
              fallbackElement={<IndexLoading />}
            />
          </AppQueryClientProvider>
        </AppMathJaxProvider>
      </AppChakraProvider>
    </AppStytchProvider>
  </AppIntercomProvider>
);

export default App;
